import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import { Icon, UserNavItem } from 'components'
import styles from './MetaNav.scss';
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';

class MetaNav extends Component {
  	render() {
	  return (
	    <nav className={styles.metaNav}>
		  {this.props.auth.isAuthenticated ? (
	    	<ul data-cy="floating-navigation">
	        	<li className={styles.rounded + ' ' + styles.addJob + ' ' + styles.isHiddenDesktop}><NavLink to="/jobs/new" activeClassName={styles.isActive}><span>+</span></NavLink></li>
	        	<li className={styles.rounded + ' ' + styles.isHiddenMobile}><a href={this.props.translate('menu.help_link')} target="_blank"><span>?</span></a></li>
				<li className={styles.rounded + ' ' + styles.roundedWithIcon}><a href={`${process.env.REACT_APP_ACCOUNT_URL}dashboard`} activeClassName={styles.isActive} data-cy="account-link"><Icon type="image" content="account" size="20px"/></a></li>
				<li className={styles.selfStyled}><UserNavItem/></li>
	        	<li onClick={this.props.onOpenMenu} data-cy="secondary-navigation"><Icon isHiddenDesktop="true" type="image" content="hamburger" /><Icon isHiddenMobile="true" type="image" content="settingsmenu" /></li>
	        </ul>
	      ) : null}
	    </nav>
	  )
	}
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onOpenMenu: () => dispatch(actionCreators.helpersMenuOpen()),
    }
};
export default connect(mapStateToProps,mapDispatchToProps)(MetaNav);


// WEBPACK FOOTER //
// ./src/components/molecules/MetaNav/index.js